// extracted by mini-css-extract-plugin
export default {"products":"os-z","card":"ps-z","oosMessaging":"qs-z"};